var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies } from "~/core/decorator";
import { PaymentCheckService } from "~/services/business-service/payment-check.service";
import { SortService } from "~/utils/sort.service";
import { Emit, Prop } from "vue-property-decorator";
import { PageService } from "~/utils/page.service";
import DataBox from "~/components/common/data-box.vue";
var RepaymentManagePending = /** @class */ (function (_super) {
    __extends(RepaymentManagePending, _super);
    function RepaymentManagePending() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = {
            state: false
        };
        _this.selectionList = [];
        _this.repaymentDataSet = [];
        _this.searchModel = {
            isReply: "NO",
            exportState: "WAIT_EXPORT"
        };
        return _this;
    }
    RepaymentManagePending.prototype.refreshList = function () { };
    RepaymentManagePending.prototype.close = function () { };
    RepaymentManagePending.prototype.approvedMeth = function (rowData) { };
    RepaymentManagePending.prototype.refreshData = function () {
        var _this = this;
        this.loading.state = true;
        this.searchModel = Object.assign(this.searchModel, this.repaymentModel);
        this.paymentCheckService.queryReplyRecord(this.searchModel, this.pageService, this.sortService, this.loading)
            .subscribe(function (data) {
            _this.repaymentDataSet = data;
        }, function (_a) {
            var msg = _a.msg;
        });
    };
    RepaymentManagePending.prototype.approvedRepaymentMeth = function (scope) {
        var rowData = scope.row;
        this.approvedMeth(rowData);
    };
    __decorate([
        Dependencies(SortService)
    ], RepaymentManagePending.prototype, "sortService", void 0);
    __decorate([
        Dependencies(PageService)
    ], RepaymentManagePending.prototype, "pageService", void 0);
    __decorate([
        Dependencies(PaymentCheckService)
    ], RepaymentManagePending.prototype, "paymentCheckService", void 0);
    __decorate([
        Emit("refreshList")
    ], RepaymentManagePending.prototype, "refreshList", null);
    __decorate([
        Emit("close")
    ], RepaymentManagePending.prototype, "close", null);
    __decorate([
        Emit("approvedMeth")
    ], RepaymentManagePending.prototype, "approvedMeth", null);
    __decorate([
        Prop()
    ], RepaymentManagePending.prototype, "repaymentModel", void 0);
    RepaymentManagePending = __decorate([
        Component({
            components: {
                DataBox: DataBox
            }
        })
    ], RepaymentManagePending);
    return RepaymentManagePending;
}(Vue));
export default RepaymentManagePending;
